document.addEventListener('turbolinks:load', function() {
  let escapeErrors = document.getElementsByClassName('js-alert-close')

  if(escapeErrors != null) {
    Array.from(escapeErrors).forEach(function(error) {
      error.addEventListener('click', function(event) {
        error.parentElement.parentElement.removeChild(error.parentElement)
      })
    })
  }
})
